<div
  class="flex items-center w-full gap-3 pb-2 pt-2"
  *ngIf="btnFields?.length"
  [ngClass]="
    btnFields[0]?.componentId === 'center-actionButton' ||
    btnFields[0]?.style?.position === 'center'
      ? 'justify-center'
      : 'justify-end'
  "
>
  <ng-container *ngFor="let position of ['start', 'center', 'end']">
    <div class="flex gap-2">
      <ng-container *ngFor="let btn of btnFields">
        <!-- [ngClass]="{
            'd-disabled': disabledBtn || (isSubmitButton(btn) && isDisabled),
          }" -->
        <button
          *ngIf="isButtonPosition(btn, position)"
          class="rounded-md transition-all flex items-center gap-2"
          [ngStyle]="getButtonStyles(btn)"
          [ngClass]="{
            'd-disabled': disabledBtn || (isSubmitButton(btn) && isDisabled),
            'cancel-modal-btn':
              btn.fieldName === 'cancelButton' ||
              btn.componentId === 'cancelButton' ||
              btn.fieldName === 'previousButton' ||
              btn.componentId === 'previousButton'
          }"
          [disabled]="btn.disabled"
          [attr.type]="isNonSubmitAction(btn) ? 'button' : 'submit'"
          (click)="onClick(btn)"
        >
          {{
            formData?.formCollection?.formDescription ===
              "Reassignment Review" && btn.displayName === "Clear All"
              ? "Cancel"
              : btn.displayName
          }}
          <div
            class="loader"
            *ngIf="
              isLoading &&
              btn.clickAction !== 'modalClose' &&
              btn.clickAction !== 'goToPreviousStep' &&
              btn.clickAction !== 'clearAll'
            "
          ></div>
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
